module.exports = __webpack_public_path__ + "media/images/icons/up-down-c6033e17a3876b87e8d0b7eb0ed952ca.png";